"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var cache_1 = require("../../cache/cache");

var QueryError_1 = require("../../client/errors/QueryError");

var clientContext_1 = require("../../context/clientContext/clientContext");

var cache = cache_1.createCache(function () {
  return true;
}, function () {
  return true;
});

exports.useSuspenseQuery = function (action) {
  var clientContext = react_1.useContext(clientContext_1.ClientContext);

  var _a = react_1.useState(null),
      flag = _a[0],
      setFlag = _a[1];

  var cacheItem = cache.get(action);
  react_1.useEffect(function () {
    if (cacheItem && cacheItem.response && flag !== null) {
      cache.remove(action);
    }

    return function () {
      cache.remove(action);
    };
  }, [cache_1.convertActionToBase64(action)]);

  var forceQuery = function forceQuery() {
    cache.remove(action);
    setFlag(!flag);
  };

  if (cacheItem) {
    if (cacheItem.response) {
      if (cacheItem.response.errorObject && cacheItem.response.errorObject instanceof QueryError_1.QueryError) {
        throw cacheItem.response.errorObject;
      }

      return __assign({}, cacheItem.response, {
        query: forceQuery
      });
    }

    throw cacheItem.fetch;
  }

  var fetch = clientContext.query(action, flag !== null).then(function (res) {
    cache.add(action, {
      fetch: fetch,
      response: res
    });
  });
  cache.add(action, {
    fetch: fetch
  });
  throw fetch;
};